<div class="row">

    <div class="col-lg-12 col-md-4 mt-4">
        <section class="card chart">
            <div class="card-body">
                <div class="row">
                    <div class="col col-6">
                        <h4 class="h4 font-weight-bold mb-0">{{positiveRating | number: '1.0-0'}}%</h4>
                        <p class="text-3 mb-0">Positive Rating</p>
                    </div>
                    <div class="col col-6 pl-0">
                        <ngx-charts-pie-chart [view]="[90,90]"
                                              [scheme]="trafficLightPalette"
                                              [results]="ratings"
                                              [legend]="false"
                                              [explodeSlices]="false"
                                              [labels]="false"
                                              [doughnut]="true"
                                              [gradient]="gradient">
                        </ngx-charts-pie-chart>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div class="col-lg-12 col-md-4 mt-4">
        <section class="card chart">
            <div class="card-body">
                <div class="row">
                    <div class="col col-6 pr-0">
                        <h4 class="h4 font-weight-bold mb-0">{{completedAudits | number: '1.0-0'}}%</h4>
                        <p class="text-3 mb-0">Audits Completed</p>
                    </div>
                    <div class="col col-6 pl-0">
                        <ngx-charts-pie-chart [view]="[90,90]"
                                              [scheme]="greenRedPalette"
                                              [results]="completed"
                                              [legend]="false"
                                              [explodeSlices]="false"
                                              [labels]="false"
                                              [doughnut]="true"
                                              [gradient]="gradient">
                        </ngx-charts-pie-chart>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div class="col-lg-12 col-md-4 mt-4">
        <section class="card chart">
            <div class="card-body">
                <div class="row">
                    <div class="col col-12">
                        <ngx-charts-bar-vertical [view]="[135,80]"
                                                 [scheme]="bluePalette"
                                                 [results]="auditsPerMonth"
                                                 [gradient]="gradient"
                                                 [xAxis]="false"
                                                 [yAxis]="false"
                                                 [legend]="false"
                                                 [barPadding]="8"
                                                 [showXAxisLabel]="false"
                                                 [showYAxisLabel]="false"
                                                 [xAxisLabel]="xAxisLabel"
                                                 [yAxisLabel]="yAxisLabel"
                                                 [showGridLines]="true">
                            
                        </ngx-charts-bar-vertical>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-6 pr-0">
                        <h4 class="h4 font-weight-bold mb-0">{{auditsPerMonthAv | number: '1.1-2'}}</h4>
                    </div>
                    <div class="col col-6 pl-0">
                        <p class="text-3 mb-0">Average<br/>Per Month</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
